import { getCommandDefinition } from './commandRegistry.js';

export function serializeCommandAction(action) {
    const definition = getCommandDefinition(action?.commandId);
    if (!definition) return action?.command ?? null;
    let command = definition.template;
    for (const parameter of definition.parameters ?? []) {
        const value = action.parameters?.[parameter.id];
        if (value == null) return null;
        command = command.split(`{{${parameter.id}}}`).join(String(value));
    }
    return command;
}
